import Vue from 'vue';

export const EventBus = new Vue();


// WEBPACK FOOTER //
// ./src/events/event-bus.js